// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"6d5023f1","353":"6207b612"}[chunkId] + ".js";
};